var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVermittlungGlobus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.43 420.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4ca7e2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #412233;\n      }\n\n      .cls-3 {\n        fill: #73617a;\n      }\n\n      .cls-4 {\n        fill: #ebc6b4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.87,
    y: 0.82,
    width: 8.19,
    height: 311.39,
    transform: "translate(-42.77 55.2) rotate(-18.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 172.42,
    y: 274.13,
    width: 30.5,
    height: 15.09,
    transform: "translate(-80.91 75.7) rotate(-18.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 90.12,
    y: 32.6,
    width: 30.5,
    height: 15.09,
    transform: "translate(-7.32 36.17) rotate(-18.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 143.14,
    y: 304.53,
    width: 16.71,
    height: 72.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 133.09,
    y: 305.18,
    width: 36.8,
    height: 17.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 145.77,
    y: 377.48,
    width: 11.43,
    height: 8.14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.34,39.42c-17.91,6.11-33.56,15.83-46.43,28.06C28.04,100.6,13.59,152.18,30.14,200.67c22.65,66.4,94.85,101.85,161.25,79.2,11.98-4.08,22.95-9.79,32.75-16.79,44.55-31.72,65.02-90.04,46.44-144.46C247.93,52.22,175.73,16.77,109.34,39.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m112.58,173.5c.81-2.47-2-2.64-2.88-4.65-1.4-3.18-.59-6.19-3.03-8.78-1.74-1.85-4.88-4.05-7.16-5.11-2.49-1.17-5.86-1.38-7.77-3.53-2.46-2.77-3.32-3.28-6.81-4.45-.96-.32-2.51-1.84-3.6-1.29-1.44.73-2.32,1.89-4.02,2.21-3.54.68-6.89-.42-10.46.74-1.83.59-3.6,1.34-5.5,1.69-1.16.21-2.57-.21-3.64.47-2.26,1.46,1.82,4.69-.01,6.83-1.45,1.7-4.79,2.38-5.55,4.56-.49,1.41-3.48,4.96-5.25,4.85-2.61-.17-1.8-4.14-4.35-3.42-2.64.74-4.95,3.69-7.24,5.17-3.21,2.07-6.13,2.54-9.5,4.04-.75.33-1.3.47-1.72.47.16,1.48.35,2.96.56,4.44.15-.13.33-.43.59-.99.27-.57.62-2.05,1.56-1.87-.02,0-.66,3.16-1.45,7.26,1.12,6.2,2.72,12.39,4.82,18.54,9.75,28.59,28.69,51.43,52.4,66.38.06-1.13.72-2.36.89-3.39.34-2.01,1.4-3.88,1.18-5.95-.22-2.11-1.17-4.08-1.24-6.21-.12-4.03,2.15-9.02.64-12.76-1.64-4.07-5.85-5.24-6.3-9.7-.37-3.61-1.38-7.49.02-11.11.67-1.73,1.96-3.47,2.02-5.39.07-2.17-1.93-2.99-2.89-4.62-2.02-3.44,1.26-5.29,3.97-6.14,1.97-.62,1.15-4.05,3.99-5.09,2.92-1.07,6.05.14,9.04-.35,1.55-.25,2.7-1.41,4.23-1.73,1.71-.35,3.48-.27,5.16-.79,7.59-2.35,5.08-10.76,8.99-15.66,2.01-2.52-.38-2.52.32-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23.39,155.19c-.11,2.94-.11,5.9,0,8.86,1.29-.82,1.81-2.58,3.96-1.82.77.27,2.26-1.21,2.67-1.64.86-.9,1.21-2.11.63-3.25-.68-1.34.98-1.21,1.01-2.2.01-.38-4.43-.28-8.26.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.1,131.47c-3.09.53-5.5,3.46-8.77,3.26-2.29-.14-3.44-4.64-2.21-6.17.17-.21,4.04-3.69,1.24-2.77-4.95,1.64-9.22-.18-14.13-1.76-1.32-.43-6.07.31-6.74-.8-.6-.97.43-2.14-.36-3.17-.3-.39-2.54-1.79-2.72-.44.33.49.73.89,1.21,1.22-.72-.25-6.4,2.85-1.38,2,1.82-.31.96,1.62-.08,1.89-2.05.54-3.67,1.79-5.7,1.74-3.15-.07-4.08,1.67-7.2,1-1.74-.37-1.15-1.4-1.56-2.71-.38-1.23-2.55.35-3.64.49-1.99,7.05-3.38,14.28-4.12,21.64,2.6,1.23,5.62,3.53,4.02,6.58,2.84.71,9.89-4.33,9.04,1.12-.18,1.18,1.07,4.9,2.48,2.63,2.23-3.57-.68-1.14-1.4-2.3-.21-.34,2.57-2.14,2.82-2.48.94-1.27.18-2.84.17-4.23-.02-3.28,5.14-5.3,6.48-8.09,1.8-3.74,2.93-.49,1.65,2.15-1.44,2.99-4.17,4.73-5.68,7.57.43.06,1.82-.69,2.16-.35.72.73.4,1.9,1.66,2.31.45.15-.21-2.39-.05-2.79.46-1.11,1.4-1.99,2.34-2.68,2.5-1.84,2.86-4.27,3.98-6.93,1.07-2.53,4.31-.29,6.12-.51,1.06-.13,4.34-2.66,4.84-.4.3,1.37,2.48,1.27,3.87,1.52,3.04.55,3.66,3.9,6.69,4.46,2.86.53,11.25-1.59,10.01-5.49-.53-1.68-3.05-7.9-5.07-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m41.89,109.28c-2.26-.39-4.63-1.87-6.78-3.04-1.12,2.42-2.16,4.88-3.13,7.36,2.29.43,5.46,1.2,2.87,4.16-1.59,1.82,2.25,2.75,3.52,4.11,2.12,2.26,4.68,1.15,5.06-1.6.53-3.85,1.1-3.18,4.4-3.54,2.83-.31,3.61-4.08,2.05-6.08-1.11-1.42-6.23-1.07-8-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m196.82,84.52h0s.03.02.04.02c-.01,0-.03-.02-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m183.36,95.15s.04.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m182.88,94.8c.11.08.25.18.44.32h0c-.1-.07-.28-.21-.44-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m255.74,95.24c.09-2.6-1.9-4.58-.12-6.75-4.78-7.07-10.21-13.57-16.18-19.44-.11-.07-.22-.14-.35-.22-.47-.31-.8-.69-1.02-1.11-9.98-9.5-21.4-17.28-33.76-23.08-1.96.22-3.8.67-5.41,2.09-1.97,1.74-5.91,2.33-8.28,3.9-2.31,1.53-.09,1.64-2.11,2.68-1.34.69-3.35.35-4.24,1.76-1.03,1.61-1.42,1.16-3.12.56-1.62-.57-3.58.03-4.88,1.05-1.8,1.41-4.27,1.43-5.94,2.85-1.57,1.33-10.38,1.95-7.34-1.36-1.25-.37-3.58-1.16-4.75-.23-1.34,1.07,2.08,2.67.22,3.4-2.1.81.04,2.98-.71,3.18-2.1.56-3.97-1.54-6.05-1.4-5.87.41.1,4.3,3.79,3.03,1.71-.59,4.88,0,6.15-1.07,1.72-1.43,1.9-.23,1.34,1.37,1.64.14,3.56.3,5.11-.44.5-.24,1.11-1,1.75-.83.71.19.24,1.33,1.29,1.46,1.06.12,2.12.2,3.19.24,2.58.14,5.2-.06,7.29,1.76.76.67.04,4.25-.79,4.8-2.3,1.51-4.19,4.14-6.7,5.21-2.45,1.03.73,3,1,4.35.98,5.07-7.26-1.62-9.09-1.83-1.71-.19-5.73-.41-5.11-2.98.42-1.74-3.41-2.49-4.47-3.34-3.42-2.74-10.36,1.16-8.12,5.43,2.21,4.21-6.87.2-7.08,1.66-.28,2.02,1.46,4.16,1.16,5.89-.21,1.21,1.27,3.19,1.22,3.34-.14.42-7.81,1.65-3.49,3.29,2.65,1.01,6.39,1.19,9.15.49,4.3-1.09,10.51-4.18,14.96-1.62,2.29,1.32-3.29,1.05-3.63.98-1.62-.31-3.29-.01-4.05,1.59,1.12.38,3.47,1.36,2.35,2.98-1.38,1.97-3.25,1.06-4.72,2.35,1.05.65,9.5,1.16,9.25.07-.27-1.23-3.87-.13-3.87-1.12,0-1.55,10.88-1.03,11.76-.2,3.1,2.92,5.75.07,8.96,2.07,2,1.25,7.35.7,7.74,3.47.52,3.68,7.37,3.51,10.31,4.35,2.87.82,4.7,2.01,5.18,5.09.24,1.53,0,4.31,1.31,5.44,2.86,2.47,1.45-7.2,1.65-7.53.94-1.55,3.22-1.72,4.43-3.03,2-2.18,3.25-.34,5.38-.04,1.89.26,3.44-2.85,5.54-3.03,1.74-.15,3.7.44,5.45.59,8.41.7,13.81,20.25,1.05,17.61-2.85-.59-5.17-5.31-8.6-1.84-.73.73,6.07,5.9,6.03,7.8-.08,3.68-8.94-.25-5.41,6.46,1.24,2.35,3.53,7.44-.58,8.81-2.59.86-4.12-.41-6.07,2.49-.79,1.17-2.26.34-3.14-.19-.98-.59-7.93-3.55-8.45-2.47-.09.19,1.9,2.64,1.91,2.67.98,2.02-.93,3.61-1.88,1.51-.68-1.5,1.05-1.28-1.25-1.92-1.29-.36-2.04-.38-2.73.86-1.88,3.42-6.46,3.97-9.35,6.28-2.95,2.35-3.01,5.49-5.31,8.03-2.91,3.22-6.56,2.57-8.7,6.93-1.55,3.16.19,5.68,2.85,6.87,4.34,1.95-.3,1.26-2.3.65-3.26-.99-3.06,2,.24,2.47-1.82,2.06-4.23-.49-6.23,1-2.14,1.6-.96,1.93-1.41,3.71-.09.34-5.49,1.62-6.17,1.98-1.91,1-2.52,1.9-3.3,3.83-1.39,3.44-7.62,3.87-3.36,8.36,3.11,3.28,8.36,4.1,9.51,8.85.99,4.08,4.11,9.6,8.32,11.08,3.13,1.09,10.33-2.13,11.2,3.39.45,2.85,4.61,5.93,6.84,7.68,1.78,1.4,3.26,3.64,5.78,2.42.86-.42,3.26-2.57,4.3-1.99.57.32-2.41,5.02-.94,6.4,1.97,1.84,4.58-.3,6.66-.02,1.29.17.58,2.14,1.45,2.85,1.18.96,1.87-.93,2.78-1.24,1.86-.65.68,2.67.25,3.1-1.25,1.25.17,1.7,1,2.85.91,1.28,2.89,1.34,2.42,3.45-.28,1.27-1.79,1.67-1.68,3.16.16,2.27,3.17,2.16,3.02,4.67-.11,1.81.68,1.74,2.35,2.01,2.32-1.9,3.78-2.86,4.48-6.09.08-.38,1.54-8.3,2.4-7.76-.99-.62-3.16-.6-2.5-2.67.55-1.74-.54-3.06.28-4.59,1.85-3.42,1.25-7.59-.47-11.19-1.5-3.15-1.48-6.56-2.09-9.92-.4-2.21-2.79-5.43-2.31-7.6.45-2.04-1.57-4.05-2.03-6.05-.5-2.2-.52-4.21.49-6.26,1.14-2.32,2.95-4.27,4.79-6.05,1.82-1.75,1.81-4.33,2.5-6.59.78-2.55,1.02-4.85,1.45-7.48.38-2.27,2-4.55,2.05-6.78.03-1.57-3.23-2.98-2.97-3.82.66-2.13,1.82-2.19-.82-3.89-3.39-2.18-8.87-4.7-8.45-9.51.16-1.86-1.19-3.73,1.2-4.43,1.78-.52,2.54,1.52,3.95.69,1.37-.8,3.32-3.03,3.99-4.43.39-.81,1.67-1.98,1.71-2.92-.19-.62-.2-1.25-.05-1.89,1.34-2.73.34-2.66,3.22-4.24,2.38-1.3,3.27-3.47,4.4-5.71,1.26-2.48,3.47-1.48,5.58-2.12,1.82-.55,3.42-2.91,4.7-4.21,1.69-1.71,3.55-3.19,4.98-5.15,1.62-2.22-.13-2.71-.85-4.73-.7-1.98,1.2-4.98,2.14-6.58.88-1.49-.22-3.28.5-5.02.74-1.77-.82-5.61.46-6.81,2.09-1.95,3.34,1.38,3.17,3.02-.07.67-1.48,10.34-.38,10.62,2.85-1.21.58-4.24,1.33-5.91,1.03-2.32.37-3.96.46-6.6Zm-59.3-10.95c-.06-.03-.1-.06-.12-.07.03.02.07.04.12.07Zm-13.7,10.41s-.05-.04-.07-.05c.02.01.04.03.07.05Zm-.11-.08s-.02-.01-.02-.01c0,0,0,0,.02.01Zm-3.5,1.62c1.1-1.46,2.49-2.36,4.18-1.12-.19-.14-.33-.24-.44-.32.16.12.34.25.44.32h0,0s.02.02.03.02c-.01,0-.02-.01-.03-.02,2.18,1.6-3.4,1.36-4.19,1.12Zm12.26.57c-1,.48-.97.17-.71-.1.08-.1.19-.21.3-.27-.81.16-3.32.58-4.57.02.89-1.72,5.11-2.26,4.98.25,0,.03,0,.07,0,.11Zm3.87-3.57c-1.44-1.66-2.52-2.75-4.83-2.96-.23-.02-2.69-.46-2.04.72.72,1.33,2.41,3.43-.85,3.07-1.07-.12-4.06-.61-4.17-1.77-.31-3.12,3.19-1.22,3.91-2.98.87-2.14-.93-4.01,2.41-5.04,2.02-.62,5.22-.92,7.13.23-.03-.02-.07-.04-.1-.06.03.02.07.04.1.06.01,0,.03.02.04.02.05.03.1.06.15.09-.05-.03-.1-.06-.15-.09-.01,0-.03-.02-.04-.02,1.75,1.05-8.26,3.79-7.79,4.35.49.57,3.9-.07,4.79.21,1.28.4,2.3,1.31,3.25,2.2,2.46,2.27.17,4.26-1.81,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m196.82,84.52h0s-.07-.04-.1-.06c.03.02.07.04.1.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "196.82 84.52 196.82 84.52 196.82 84.52 196.82 84.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "183.32 95.13 183.32 95.13 183.32 95.13 183.32 95.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.69,96.71c-.12.16-.18.32-.05.34.25-.08.5-.16.76-.24,0-.04,0-.07,0-.11,0-.48-.47-.25-.72,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m191.26,96.38s-.1.02-.27.06c.1-.06.19-.08.27-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.31 77.19 61.31 77.19 61.31 77.19 61.31 77.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.22,77.21s.06-.01.08-.02c-.03,0-.06.01-.08.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.4,77.18s.02,0,.02,0h0s0,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "61.44 77.17 61.44 77.17 61.43 77.17 61.44 77.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.31,77.19s.06-.01.09-.02c-.03,0-.06.01-.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.44,77.17s.01,0,.01,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.28,61.76c-6.45,1.89-12.65-.14-19.12,2.54-6.41,2.66-13.95,4.74-20.77,6.04-3.37.64-6.09,1.1-9.07,2.94-2.34,1.45-4.42,3.43-7.22,3.95.04,0,.08-.02.12-.02.03,0,.05,0,.08-.02.04,0,.07-.01.11-.02,0,0,.01,0,.02,0h0c.07-.01.13-.03.2-.04.04,0,.07-.01.11-.02h0c-.98.18-1.76.35-2.53,1.04,2.64.63,6.58-1.86,8.93.15.61.52.58,1.34.38,2.05,1.09.31,2.11.76,3.07,1.36,1.44.71,3.79,1.12,5.38.9.78-.47,1.63-.68,2.54-.61.28.15-2.57,3.22-2.78,3.58-1.14,1.96,4.72-2.14,4.93-2.17.07.83,2.23,1.91.85,2.4-.8.28-2.84.2-2.95,1.45,0,.05,8.2-.95,9.08-1.52,2.46-1.57,5.11-.05,7.64.38,3.04.52,5.9-1.24,8.93-.76,3.2.51,4.81,3.54,7.73,4.42,5.94,1.81,8.09-10.62,1.09-11.85-2.36-.41-4.77-2.44-2.91-4.86,1.22-1.59-.71-3.64.95-5.7,2.01-2.52,5.29-2.57,7.89-4.12,3.71-2.2-1.02-2-2.7-1.51Zm-55.07,15.26s.02,0,.02,0c0,0-.01,0-.02,0Zm.05,0s.09-.02.13-.02c-.04,0-.08.01-.13.02Zm.25-.05s.03,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m61.1,77.23c-.06.01,0,0,.12-.02-.04,0-.08.01-.12.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.61 72.62 131.61 72.62 131.61 72.62 131.61 72.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.31,72.98s-.03.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.61 72.62 131.61 72.62 131.61 72.62 131.61 72.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.61,72.62h0s.02-.03.03-.04c0,0-.02.02-.03.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.33,72.96s0,0,.03-.03c-.02.02-.03.04-.04.05,0,0,0-.01.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m145.79,58.82c.28.21,2.65,1.2,2.2,1.77-.85,1.08-4.67-1.55-6.66.35-1.84,1.76-3.08,2.05-5.11,3.18-.97.54-.82,2.37-1.95,3.13-.63.33-1.25.66-1.88.99-.96.65.2,3.21-1.03,4.69-1.49,1.79-.08,4.31,1.99,2.39.55-.51,3.12-3.83,3.38-1.13.56,5.99,2.07-.09,4.79,1.48.23.13-1.37,1.72-1.22,2.16.8,2.37,4.43-3.56,4.58-3.74,1.43-1.57.93-2.81,3.71-2.55.13.01,2.37-.03,1.74-.98-.8-1.21-4.49,1.49-5.66,1.25-2.46-.49-2.43-.97-4.91.21-3.85,1.82,1.03-6.62,2.02-7.33.84-.6,12.56-2.79,11.06-4.94-1.03-1.47-5.51-1.37-7.04-.93Zm-14.18,13.8h0s0,0,0,.01c0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s.02-.03.03-.04c0,0-.02.02-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.61,72.62h0s.02-.03.03-.04c0,0-.02.02-.03.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m170.67,54.34s-.03.04,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.08,44.83c-2.11-.64-10.63-.99-11.23,2.64.69-.15,1.38-.14,2.07.03-2.26,1.96-7.69,1.8-7.57,4.55-.2,0-4.7-1.71-4.08-.35.35.77,2.13,1.56,1.4,2.64h0c-2.06,3.06,4.73.47,6.11-.17,2.45-1.13,4.71.63,7.3-1.01.1-.06,3.4-2.61,2.61-2.88-1.42-.49-3.09,1.67-4.57.56.18.13,3.99-1.7,4.44-1.95-.04-.66-2.29.18-2.72-.09.66-2.67,4.17-2.05,6.09-1.93,2.53.15,2.04-1.46.14-2.03Zm-19.08,9.03s-.09.13-.16.23c-.06.09-.12.19-.16.24.04-.05.1-.15.16-.24.06-.1.13-.19.16-.23.01-.02.02-.02.02-.02,0,0,0,0-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m170.84,54.09c.08-.12.13-.2.16-.23-.03.04-.09.13-.16.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m108.29,58.94h0s0,0,0,0c-.01,0-.01,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m134.64,55.92c-.8.26-1.63.44-2.46.54,1.16-5.04-5.34,2.15-8.15.55,0,0,5.55-3.03,6.03-3.44-7.23.11-14.76,3.8-21.77,5.37,0,0,0,0,0,0,.02,0,.03,0,.04,0-.01,0-.03,0-.04,0,1.03-.23-.94.32-.85.28,4.05,3.42,12.68-.95,17.2-.74,2.82.13,6.16,1.79,8.9.47.88-.42,6.97-2.59,6.68-3.79-1.47.44-5.32,3.13-5.6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m62.09,120.86c.08-.02.13-.03.13-.03.54-1.31-.23-.11-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m67.27,121.53c.01-.91,1.34-1.23,1.94-1.56-2.22-1.88-5.5-2.09-2.33-4.69.92-.76-.04-2.88-.69-3.49-1.41-1.34-1.73.64-2.63,1.36,1.69.96-.55,5.74-1.35,7.68-.07.05-.11.05-.13.03-.35.1-1.33.42-1.46.99,1.04.38,1.97.37,2.04,1.74,1.65-.2,3.22-.76,4.85-1.02.32-.05,3.12-.69,3.02-.77-.39-.31-3.28.43-3.27-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.85,129.82s.02-.01.03-.02h0s-.02.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "201.88 129.79 201.88 129.79 201.88 129.79 201.88 129.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.96,129.73s-.05.04-.07.06h0s.05-.04.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.88,129.79s.04-.03.07-.06c-.03.02-.05.04-.07.06.89-.68-1.71,1.62-1.98,2.05,4.19-.48,5.19-1.65,7.25-4.78,2.22-3.36,4.8-2.23,7.89-3.43-4.99-3.56-9.73,3.55-13.16,6.16Zm.34-.26c.13-.1.24-.18.34-.26-.1.08-.21.16-.34.26Zm.85-.65s.09-.07.12-.09c-.03.02-.07.05-.12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.85,129.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75.33,94.51s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.3,93.76c-1.7.27-3.43.65-5.14.75.07,0,.14,0,.17-.01,0,0,0,0,0,0,.01,0,.02,0,.02,0,0,0,0,0-.01,0,0,0,0,0-.01,0-.03,0-.08,0-.17.01-1.53.1-2.5.68-3.32,1.97,2.24.7,4.51.6,6.82.59,2.04,0,1.17-1.94,2.7-2.18,2.27-.35.42-1.37-1.07-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75.16,94.52h0c-.2.01-.51.03-.62.04.08,0,.27-.02.62-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.54,94.56c-.06,0-.07,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.9,99.98s.02-.01.04-.02c-.01,0-.02.01-.04.02-2.13,1.09-1.27,2.58.89,2.1,2.44-.55,4.55-1.67,6.89-2.48-.62-.22-7.11-3.71-7.33-2.76-.31,1.34,2.23,1.79-.44,3.15Zm.08-.04s.01,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.78,100.04s.04-.02.07-.03h0s.03-.02.05-.03h0s-.1.05-.16.08c.01,0,.03-.01.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.64,100.11s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.61,100.13s0,0,0,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "141.63 100.12 141.63 100.12 141.64 100.11 141.63 100.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.61,100.13s-.02.01-.03.01c0,0,.02,0,.03-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.58,100.14s-.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.65,100.11s.03-.02.05-.03c0,0,0,0-.01,0-.01,0-.03.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.71,100.08h.01s0-.01.02-.02c0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.71,100.08h0s.05-.03.07-.04c-.02,0-.04.02-.05.03,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.64,100.11s.01,0,.02-.01h0s-.01.01-.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.69,100.08s-.03.01-.04.02c.01,0,.03-.02.05-.03,0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.78,100.04s.05-.02.07-.04c-.02.01-.04.02-.06.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "141.61 100.13 141.62 100.12 141.62 100.12 141.61 100.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.98,116.85c-1.02.51.63,1.23,1.26,2.69.92,2.13,2.57.71,4.44,1.16,1.78.42-.12-3.47-.49-3.98-.67-.95-4.34-.3-5.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.98,116.85c.06-.03.1-.05.13-.06-.05.02-.11.06-.17.09.02,0,.03-.01.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m71.11,116.79c.1-.05.07-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.93,116.87s-.07.04-.1.05c.02-.01.06-.03.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.84,116.92c-.07.03-.05.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.81,58.79s.05-.03.06-.04c-.01,0-.03.02-.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.53,58.96c.14-.08.23-.14.29-.17-.07.04-.17.1-.29.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.89,59.35s.08-.04.11-.07c-.04.02-.07.04-.09.06,0,0-.01,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.34,59.07s.04-.03.06-.04c-.01,0-.02.01-.04.02.03-.02.06-.04.09-.05-.13.03-.19.11-.28.17.05-.03.11-.07.17-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.01,59.28s.02-.01.03-.02c.02-.02.05-.03.08-.05.01,0,.02-.01.03-.02-.05.03-.1.05-.14.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.15,59.19s.02-.01.03-.02c0,0-.01,0-.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.15,59.19h0s.03-.02.04-.03c-.01,0-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.88,58.75s.01,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.49,58.98s.02-.01.03-.02c-.01,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.38,56.54c-2.28,1.48-5.16,1.41-7.48,2.81-.1.13-.17.28-.19.47.89,1.88,12.79-3.64,12.5-4.38-.94-2.36-3.95.53-4.82,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.87,59.36s.01,0,.02-.01h0s0,0,0,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.87,59.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.91,59.34s-.01,0-.02,0h0s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.91,59.34s0,0,.01,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.04,59.26s.03-.02.04-.03c-.02.01-.05.03-.07.04,0,0,.02,0,.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.01,59.28h0s-.06.03-.09.05c.03-.02.06-.04.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.12,59.21s.02-.01.03-.02c-.02.01-.04.03-.07.04.01,0,.02-.01.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.41,59.04s.06-.04.09-.05c-.01,0-.02.01-.04.02-.02.01-.04.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.89 260.89 213.89 260.89 213.89 260.89 213.89 260.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.92,260.85h0s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "214.04 260.71 214.05 260.7 214.04 260.71 214.04 260.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.09,260.65s-.04.04-.05.06c-.04.05-.08.1-.12.14,0,0,.01-.01.02-.02,0,0-.01.01-.02.02,0,.01-.02.02-.03.03,0,0,0,0,0,0h0c-.05.06-.09.1-.11.13,0,0,.05-.06.11-.13,0,0,0,0,0,0h0s0,0,0,0c.05-.05.1-.11.14-.17h0s.03-.04.05-.06c-1.09,1.31-2.6,2.19-3.62,3.56,2.08-.14,5.41-.99,6.51-3.03,1.28-2.37-1.92-1.71-2.89-.53Zm-.35.43s0,0,.01-.02c0,0-.01.02-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.04,260.71s.04-.04.05-.06c-.02.02-.03.04-.05.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.89 260.89 213.89 260.89 213.89 260.89 213.89 260.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "213.89 260.89 213.89 260.89 213.89 260.89 213.9 260.89 213.89 260.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "214.04 260.71 214.05 260.7 214.04 260.71 214.04 260.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.09,260.65s-.03.04-.04.05c.02-.02.03-.04.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.18,260.55s0-.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.09,260.65h0s.03-.04.04-.05c-.01.01-.02.03-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.13,260.6s.03-.04.04-.05c0,0-.02.03-.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m213.9,260.88s.02-.02.02-.03c0,0-.02.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m193.9,135.39s.05-.04.09-.08c-.04.04-.08.06-.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.02,135.29c-.53.51-.92,1.11-1.18,1.8,1.38.89,4.66-.13,5.84-1.04.91-.7.36-1.47.14-2.33-1.39.25-3.66.65-4.8,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.15,135.19s.02-.01.02-.02c0,0-.02.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.17,135.17s.05-.04.07-.06c-.01.01-.04.03-.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m193.9,135.39s-.01.01,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194,135.31s.1-.09.15-.13c-.03.03-.08.06-.13.1-.01,0-.02.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.24,135.11s.03-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.27,53.85h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.49,54.06c-.11-.11-.18-.17-.23-.21.06.05.14.13.23.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.25,53.84s-.06-.06,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.68,54.24s.06.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.68,54.24s.06.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m162.49,54.06c.1.09.16.14.19.18-.04-.03-.1-.09-.19-.18-1.06-.97-2.95-.33-4.17-.24,1.3,1.63,6.92,3.56,6.82-.45-1.02-.47-1.8,1.47-2.64.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m157.08,68.03s.06-.07.09-.1c-.02.03-.05.06-.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m157.08,68.03c-.09.1-.2.22-.29.33.13-.14.22-.25.29-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.78,68.35c-.05.05-.1.11-.15.17.04-.05.1-.11.15-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.57,68.59s-.02.02.01-.01c0,0,0,0-.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.58,68.58s.03-.04.05-.06c-.02.02-.04.04-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m157.17,67.93c.09-.1.11-.12,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.57,68.59c-2,2.22,5.25.4,5.65-.85-2.02-.79-4.09-.88-5.65.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.41,51.25c-1.04.13-1.83.64-2.38,1.54.92.52,7.27.12,6.22-1.15-.65-.79-2.95-.42-3.84-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.8,55.66c.42-.11.13-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.2,55.6c-.19.02-.33.04-.41.06.32-.08.43-.1.41-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.76,55.67s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.2,55.6c-.06.1-1.33.63-1.71,1.06.62.45,5.69.26,5.79-.47.12-.85-2.9-.73-4.08-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m152.76,55.67s.02,0,.04-.01h0s-.03,0-.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m204.84,259.73c-.65.08-2.48.79-3.52,1.53.65.25,4.71.28,3.99-1.13.02-.03-.05-.14-.29-.4-.1-.02-.15-.02-.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.93,144.37h0s0-.02,0-.04c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.93,144.37h0c-.02,1.11,1.76,3.47,1.99,1.24.15-1.53-1.95-2.79-1.99-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.93,144.33c0-.07,0-.14,0-.17,0,.03,0,.08,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.93,144.16s0-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.92,144.51s0,.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m52.38,150.93c.04-.05.09-.11.14-.18-4.31-.6-3.23,4.16-.14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.57,58.08s-.06.1-.07.16c-.5-.27-1.64-.74-2.95.13,1.07.69,2.59,1.22,3.36.2.09-.1.18-.26.27-.51-.15-.07-.28-.09-.37-.09-.18-.02-.25.02-.24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.35,132.46c.06,0,.16-.02.24-.04-.07,0-.13.02-.2.03-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.32,132.46s-.03,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.58,132.42s.02,0,.02,0c-.04,0-.07.01-.1.02-.05,0-.09.01-.12.02-.02,0-.05,0-.07.01-.69.15-1.18.58-1.45,1.29,1.6.99,3.08-1.53,1.79-1.34-.03,0-.05,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.79,132.39c.07-.01.15-.02.2-.03-.05,0-.12.02-.2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m207.99,132.36s.01,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m208.06,132.35s.02,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m208.06,132.35s-.03,0-.06,0c.03,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m36.83,160.62c-1.42.13-2.33.44-2.95,1.29,1.2.11,1.49,0,2.95-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.82,154.03s.01,0,.02-.01c0,0-.01,0-.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.78,154.06s.02-.01.03-.02c0,0-.01,0-.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.85,154.01h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "186.81 154.04 186.81 154.04 186.81 154.04 186.81 154.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "186.81 154.04 186.81 154.04 186.81 154.04 186.81 154.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.85,154.01s.03-.02.03-.02c0,0-.01,0-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.75,154.08s.04-.03.05-.03c0,0-.01,0-.02.01,0,0-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.94,153.95s.01,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.61,154.17s.04-.02.08-.05c-.03.02-.06.04-.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.69,154.11c-.13.52-.12,1.05.03,1.57.5-.11.95-.31,1.37-.59.32-.51-.91-1.29-1.4-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.51,154.23s-.01,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.6,154.17h.01s-.01,0-.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.59,154.18h0s-.07.05-.09.05c.01,0,.04-.02.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.6,154.17s.1-.07.15-.1c-.02.01-.04.02-.06.04-.04.02-.07.04-.09.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "186.6 154.17 186.6 154.17 186.6 154.17 186.6 154.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.89,153.99s.04-.03.06-.04c0,0-.03.02-.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.87,134.31c.05-.01.12-.03.2-.05-.05.01-.13.03-.21.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.72,134.35s.09-.02.14-.04h0c-.07.02-.11.03-.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.87,134.31h.02s-.02,0-.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.89,134.3s.1-.03.18-.05c-.8.23-1.54.59-2.22,1.07,1.49,1.13,2.34-1.1,2.22-1.07.25-.07.55-.15,0,0-.1.03-.15.04-.18.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.72,134.35s-.03,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.52,138.55c.14-.04.29-.08,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m188.92,139.08c1.43,1.48,2.16-.69,1.6-.53-.26.07-.13.04,0,0-.29.08-.1,0,.27-.15-.51.18-1.12.41-1.87.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m190.79,138.4c3.91-1.43,1.12-.44,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m55.13,141.26c0,.46.17.84.52,1.14.44-.25.58-.61.44-1.07-.07-.03-.43-.28-.96-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.09,141.31s.02.03,0,.02c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.18,141.43c.05.07.04.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.09 141.31 56.09 141.31 56.09 141.31 56.09 141.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.09,141.31s.06.08.09.12c-.02-.03-.05-.06-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.09,141.31s-.02-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m66.6,143.2c.62-.33-.07-1.1-.59-.74-.55.38.41.68.59.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24.12,165.79s.02.05,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24.02,165.56c.05.12.08.2.1.23-.02-.05-.07-.16-.1-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24.01,165.52s0,.02.01.04c0,0,0,0,0,0,0-.02,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24,165.52s-.01-.03,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m199,145.95c-.71.86.86.43,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m197.16,147.05c-.02.32-.15.36-.38.14.04-.3.17-.34.38-.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.03,205.7C-8.08,132.1,31.36,51.79,104.96,26.68l-3.06-8.96C23.37,44.52-18.72,130.22,8.07,208.75c26.8,78.54,112.49,120.63,191.02,93.83l-3.06-8.95c-73.6,25.11-153.9-14.33-179.02-87.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.63,
    y: 3,
    width: 20.73,
    height: 13.07,
    transform: "translate(2.01 31.18) rotate(-18.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 117.87,
    y: 385.62,
    width: 65.05,
    height: 17.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.38,
    y: 402.99,
    width: 132.21,
    height: 17.37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVermittlungGlobus);
export default __webpack_public_path__ + "static/media/vermittlung-globus.31a781f2d6d4c0c7cf9dbec94d24df12.svg";
export { ForwardRef as ReactComponent };